import axios from '@axios'

export default {
  loadTable(queryFilter) {
    let queryUrl = ''
    queryUrl = `?page=${queryFilter.page - 1}&size=${queryFilter.size}&sort=${queryFilter.sort},${queryFilter.order}`
    if (queryFilter.filter) {
      queryUrl = `/pesquisa?${queryFilter.filter}`
    }
    return axios.get(`/core/profissoes${queryUrl}`)
  },
  insertNewProfession(data) {
    return axios.post('/core/profissoes', data)
  },
  editProfession(data) {
    return axios.put(`/core/profissoes/${data.id}`, data)
  },
  deleteProfession(id) {
    return axios.delete(`/core/profissoes/${id}`)
  },
}
